import React, { useEffect, useState } from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { toast } from 'sonner';

const EMPTY = { name: '', function: '', phone: '', email: '' };

export function ContactFormDialog({ open, onOpenChange, initial, onSave, title }) {
  const [data, setData] = useState(EMPTY);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) setData(initial ? { ...EMPTY, ...initial } : EMPTY);
  }, [open, initial]);

  const field = (key) => ({
    value: data[key] || '',
    onChange: (e) => setData({ ...data, [key]: e.target.value }),
  });

  const handleSave = async () => {
    const payload = Object.fromEntries(Object.entries(data).map(([k, v]) => [k, typeof v === 'string' ? v.trim() : v]));
    if (!payload.name) return toast.error("Le nom complet de l'interlocuteur est obligatoire");
    if (!payload.function) return toast.error('La fonction / le rôle est obligatoire');
    if (!payload.email) return toast.error("L'email est obligatoire");
    setSaving(true);
    try {
      await onSave({ name: payload.name, function: payload.function, phone: payload.phone, email: payload.email });
      onOpenChange(false);
    } catch (error) {
      const detail = error.response?.data?.detail;
      toast.error(Array.isArray(detail) ? 'Email invalide' : detail || "Erreur lors de l'enregistrement");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="contact-form-dialog">
        <DialogHeader>
          <DialogTitle className="text-[#1e3a8a]">{title || 'Nouvel interlocuteur'}</DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          <div className="space-y-1.5">
            <Label>Nom complet *</Label>
            <Input {...field('name')} placeholder="Jean Dupont" data-testid="contact-form-name-input" />
          </div>
          <div className="space-y-1.5">
            <Label>Fonction / Rôle *</Label>
            <Input {...field('function')} placeholder="Trésorier, Curé, Secrétaire..." data-testid="contact-form-function-input" />
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <div className="space-y-1.5">
              <Label>Téléphone</Label>
              <Input {...field('phone')} placeholder="06 12 34 56 78" data-testid="contact-form-phone-input" />
            </div>
            <div className="space-y-1.5">
              <Label>Email *</Label>
              <Input type="email" {...field('email')} placeholder="jean@exemple.fr" data-testid="contact-form-email-input" />
            </div>
          </div>
        </div>
        <DialogFooter>
          <Button type="button" variant="outline" onClick={() => onOpenChange(false)} data-testid="contact-form-cancel-button">
            Annuler
          </Button>
          <Button type="button" onClick={handleSave} disabled={saving} className="bg-[#1e3a8a] hover:bg-[#1e40af]" data-testid="contact-form-save-button">
            {saving ? 'Enregistrement...' : 'Enregistrer'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
